import { Component, OnInit } from '@angular/core';
import { EventsService } from 'src/app/services/event/event.service';
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

import { ConfigService } from 'src/app/services/config/config.service';
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";

@Component({
    selector: 'ask-customer-rotate',
    templateUrl: './ask-customer-rotate.component.html',
    styleUrls: ['./ask-customer-rotate.component.scss'],
})

export class AskCustomerRotateComponent implements OnInit {
    private timerIdAutoHide: any;
    private skipBtnName: string;
    private checkBoxLabel: string;
    private titleLabel: string;
    private hasSkipBtn: boolean = true;
    private hasCheckbox: boolean = false;
    private autoHideTimeoutValue: number = 3000;
    private notShowAskRotateAgain: boolean = false;
    private isPortait: boolean = false;
    constructor(
        private readonly events: EventsService,
        private config: ConfigService,
        private screenOrientation: ScreenOrientation,
        private appStorage: AppstorageTsService,
    ) {
        this.autoHideTimeoutValue = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_TIMEOUT || 5000;
        this.skipBtnName = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_SKIP_BTN_NAME || "Skip";
        this.hasSkipBtn = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_HAS_SKIP_BTN || true;
        this.hasCheckbox = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_HAS_CHECKBOX || false;
        this.checkBoxLabel = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_CHECKBOX_LABEL || "Don’t Show this again";
        this.titleLabel = this.config.getConfig().TELL_CUSTOMER_ROTATE_SCREEN_TITLE_LABEL || "Please rotate your device for the best gameplay experience.";
        this.isPortait = this.screenOrientation.type == "portrait-primary";
        this.screenOrientation.onChange().subscribe(
            () => {
                if (this.isPortait) {
                    this.onClose();
                }
            }
        );

    }

    ngOnInit(): void {
        this.callAutoHide();
    }

    onClose = () => {
        clearTimeout(this.timerIdAutoHide);
        this.events.publish("event:notifyCustomerRotate:end");
    }
    //in case we need to add don't show again
    // onUpdateSkip (){
    //     this.notShowAskRotateAgain = ! this.notShowAskRotateAgain;
    //     if(this.notShowAskRotateAgain){
    //         this.appStorage.setSkipAskCustomerRotate(true);
    //     } else{
    //         this.appStorage.setSkipAskCustomerRotate(false);
    //     }
    // }

    onSkip = () => {
        this.appStorage.setSkipAskCustomerRotate(true);
        this.onClose();
    }

    callAutoHide() {
        this.timerIdAutoHide = setTimeout(() => {
            this.onClose();
        }, this.autoHideTimeoutValue);
    }

    ngOnDestroy() {
        if (this.timerIdAutoHide) {
            clearTimeout(this.timerIdAutoHide);
            this.timerIdAutoHide = null;
        }
        this.screenOrientation = null;
    }

}